type Props = { size?: number; className?: string };

/**
 * Coin — tiny circular icon for rewards. Renders an SVG zł coin in sunny+gold.
 * Designed to sit next to MoneyText on task cards (handoff §5.5).
 */
export function Coin({ size = 28, className }: Props) {
  return (
    <svg
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      aria-hidden
    >
      <circle cx="16" cy="16" r="14" fill="var(--kd-sunny)" />
      <circle
        cx="16"
        cy="16"
        r="14"
        fill="none"
        stroke="var(--kd-gold)"
        strokeWidth="2"
      />
      <text
        x="16"
        y="21"
        textAnchor="middle"
        fontFamily="Bricolage Grotesque, DM Sans, sans-serif"
        fontWeight="800"
        fontSize="13"
        fill="#7A4A00"
      >
        zł
      </text>
    </svg>
  );
}
